/** Keeps backend diagnostics out of messages shown to authors. */
export function userFacingError(error: unknown, fallback: string): string {
  const message = typeof error === 'string' ? error
    : error && typeof error === 'object' && 'message' in error ? error.message : '';
  return typeof message === 'string' && message && !/appwrite/i.test(message) ? message : fallback;
}
